import { useRef, useState } from "react"

import type { AiImageSpec } from "@productlane/lib/src/ai"
import { cn } from "@productlane/lib/src/cn"

import { ImageViewer } from "../image-viewer/image-viewer"
import { AnnotationOverlay } from "./annotation-overlay"

export const AiAnnotatedImage = ({
	spec,
	className,
}: {
	spec: AiImageSpec
	className?: string
}) => {
	const width = spec.width > 0 ? spec.width : 1200
	const height = spec.height > 0 ? spec.height : 800
	const imgRef = useRef<HTMLImageElement>(null)
	const [viewerOrigin, setViewerOrigin] = useState<DOMRect | null>(null)

	return (
		<figure className={cn("relative my-4 w-full", className)}>
			<button
				type="button"
				aria-label="View full size"
				className="relative block w-full cursor-zoom-in"
				onClick={() =>
					setViewerOrigin(imgRef.current?.getBoundingClientRect() ?? null)
				}
			>
				<img
					ref={imgRef}
					src={spec.src}
					alt={spec.alt}
					width={width}
					height={height}
					className="h-auto w-full rounded-md ring-1 ring-black/5 dark:ring-white/10"
					loading="lazy"
				/>
				<AnnotationOverlay
					annotations={spec.annotations}
					width={width}
					height={height}
				/>
			</button>
			{spec.caption && (
				<figcaption className="mt-1.5 text-xs text-secondary">
					{spec.caption}
				</figcaption>
			)}
			{viewerOrigin && (
				<ImageViewer
					images={[
						{
							src: spec.src,
							alt: spec.alt,
							name: spec.alt,
							width,
							height,
							annotations: spec.annotations,
						},
					]}
					index={0}
					originRect={viewerOrigin}
					onIndexChange={() => undefined}
					onClose={() => setViewerOrigin(null)}
				/>
			)}
		</figure>
	)
}
